import { TinymceComponent } from './tinymce/tinymce.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '../core';

import { FormsComponent } from './forms/forms.component';
import { Ng2TableComponent } from './ng2-table/ng2-table.component';
import { DateComponent } from './date/date.component';
import { DataTableComponent } from './data-table/data-table.component';
import { ControlSelectComponent } from './control-select/control-select.component';
import { CalculatorjsComponent } from './calculatorjs/calculatorjs.component';
import { SelectorModalComponent } from './selector-modal/selector-modal.component';
import { NumericDecimalComponent } from './numeric-decimal/numeric-decimal.component';
import { GalleryFilesComponent } from './gallery-files/gallery-files.component';
import { WebSocketComponent } from './websocket/websocket.component';

const routes: Routes = [
  Route.withShell([
    {
      path: 'examples/dynamic-form',
      component: FormsComponent
    },
    {
      path: 'examples/ng2-table',
      component: Ng2TableComponent
    },
    {
      path: 'examples/date',
      component: DateComponent
    },
    {
      path: 'examples/smart-table',
      component: DataTableComponent
    },
    {
      path: 'examples/select',
      component: ControlSelectComponent
    },
    {
      path: 'examples/calculatorjs',
      component: CalculatorjsComponent
    },
    {
      path: 'examples/modal-select',
      component: SelectorModalComponent
    },
    {
      path: 'examples/numeric-decimal',
      component: NumericDecimalComponent
    },
    {
      path: 'examples/gallery-file',
      component: GalleryFilesComponent
    },
    {
      path: 'examples/tinymce-editor',
      component: TinymceComponent
    },
    {
      path: 'examples/websocket',
      component: WebSocketComponent
    },
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ExamplesRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/examples/examples-routing.module.ts